export class GroupInquiryActions {
    assignToUserId: string;
    assignRequestType: string;
    assignToTag: string;
    assignProcessingRegion: string;
    markAsNonInquiry: boolean;
    markForDeletion: boolean;
    assignGroup: string;
}
